import React from "react";
import { Box, Typography, Grid, useTheme, useMediaQuery } from "@mui/material";
import { LocationOn } from "@mui/icons-material";

const countries = [
  { name: "Switzerland", projects: 6 },
  { name: "France", projects: 5 },
  { name: "India", projects: 4 },
  { name: "UK", projects: 3 },
  { name: "Italy", projects: 2 },
  { name: "Thailand", projects: 1 },
];

const FootprintComponent = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box
      sx={{
        py: 8,
        px: isMobile ? 2 : 6,
        // backgroundColor: "#f8f9fa",
        position: "relative",
        overflow: "hidden",
        minHeight:"90vh",
      }}
    >
      {/* Background pattern */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background:
            "radial-gradient(circle, rgba(0,150,136,0.1) 0%, rgba(255,255,255,0) 70%)",
          zIndex: 0,
        }}
      />

      <Box sx={{ position: "relative", zIndex: 1 }}>
        <Typography
          variant="h3"
          component="h2"
          sx={{
            textAlign: "center",
            mb: 6,
            fontWeight: 700,
            color: theme.palette.primary.dark,
            fontSize: isMobile ? "2rem" : "3rem",
          }}
        >
          GREENENCO pvAPM{" "}
          <span style={{ color: theme.palette.secondary.main }}>FOOTPRINT</span>
        </Typography>

        <Grid container spacing={4} justifyContent="center">
          {countries.map((country, index) => (
            <Grid item xs={6} sm={4} md={2} key={country.name}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  p: 3,
                  backgroundColor: "white",
                  borderRadius: 4,
                  boxShadow: 3,
                  transition: "transform 0.3s, box-shadow 0.3s",
                  "&:hover": {
                    transform: "translateY(-10px)",
                    boxShadow: 6,
                  },
                  height: "100%",
                }}
              >
                <Box
                  sx={{
                    width: isMobile ? 60 : 80,
                    height: isMobile ? 60 : 80,
                    borderRadius: "50%",
                    backgroundColor: theme.palette.primary.light,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mb: 2,
                    color: "white",
                    fontSize: isMobile ? "1.5rem" : "2rem",
                    fontWeight: 700,
                  }}
                >
                  {countries.length - index}
                </Box>
                <LocationOn color="primary" sx={{ fontSize: "2rem", mb: 1 }} />
                <Typography
                  variant="h6"
                  sx={{
                    textAlign: "center",
                    fontWeight: 600,
                    color: theme.palette.text.primary,
                  }}
                >
                  {country.name}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    textAlign: "center",
                    color: theme.palette.text.secondary,
                    mt: 1,
                  }}
                >
                  {country.projects}{" "}
                  {country.projects > 1 ? "Projects" : "Project"}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>

        <Typography
          variant="body1"
          sx={{
            textAlign: "center",
            mt: 6,
            color: theme.palette.text.secondary,
            maxWidth: 800,
            mx: "auto",
            px: isMobile ? 2 : 4,
          }}
        >
          Our global presence spans across multiple continents, delivering
          cutting-edge solar solutions and sustainable energy innovations to
          partners worldwide.
        </Typography>
      </Box>
    </Box>
  );
};

export default FootprintComponent;

// import React, { useRef, useEffect } from 'react';
// import { Box, Typography, useTheme, useMediaQuery } from '@mui/material';
// import { LocationOn } from '@mui/icons-material';
// import { LoadScript, GoogleMap, Marker } from '@react-google-maps/api';

// const countries = [
//   { name: 'Switzerland', projects: 6, lat: 46.8182, lng: 8.2275 },
//   { name: 'France', projects: 5, lat: 46.2276, lng: 2.2137 },
//   { name: 'India', projects: 4, lat: 20.5937, lng: 78.9629 },
//   { name: 'UK', projects: 3, lat: 55.3781, lng: -3.4360 },
//   { name: 'Italy', projects: 2, lat: 41.8719, lng: 12.5674 },
//   { name: 'Thailand', projects: 1, lat: 15.8700, lng: 100.9925 }
// ];

// const mapContainerStyle = {
//   width: '100%',
//   height: '100%'
// };

// const center = {
//   lat: 30,
//   lng: 10
// };

// const FootprintMap = () => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//   const mapRef = useRef(null);

//   useEffect(() => {
//     if (mapRef.current) {
//       // Add any map initialization logic here
//     }
//   }, []);

//   return (
//     <Box sx={{
//       height: '100vh',
//       width: '100%',
//       position: 'relative',
//       overflow: 'hidden'
//     }}>
//       {/* Overlay title */}
//       <Box sx={{
//         position: 'absolute',
//         top: 0,
//         left: 0,
//         width: '100%',
//         zIndex: 2,
//         textAlign: 'center',
//         pt: 8,
//         px: 2,
//         pointerEvents: 'none'
//       }}>
//         <Typography variant="h2" component="h2" sx={{
//           fontWeight: 700,
//           color: 'white',
//           textShadow: '0 2px 10px rgba(0,0,0,0.5)',
//           fontSize: isMobile ? '2.5rem' : '3.5rem',
//           mb: 1
//         }}>
//           GREENENCO <span style={{ color: theme.palette.secondary.light }}>GLOBAL FOOTPRINT</span>
//         </Typography>
//         <Typography variant="h6" sx={{
//           color: 'rgba(255,255,255,0.9)',
//           textShadow: '0 1px 4px rgba(0,0,0,0.5)',
//           maxWidth: 800,
//           mx: 'auto'
//         }}>
//           Our solar solutions span across {countries.length} countries worldwide
//         </Typography>
//       </Box>

//       {/* Google Map */}
//       <LoadScript
//         googleMapsApiKey="YOUR_GOOGLE_MAPS_API_KEY"
//         loadingElement={<Box sx={{ height: '100%', backgroundColor: '#e0e0e0' }} />}
//       >
//         <GoogleMap
//           mapContainerStyle={mapContainerStyle}
//           center={center}
//           zoom={2}
//           options={{
//             styles: [
//               {
//                 featureType: "poi",
//                 stylers: [{ visibility: "off" }]
//               },
//               {
//                 featureType: "transit",
//                 stylers: [{ visibility: "off" }]
//               },
//               {
//                 featureType: "administrative",
//                 stylers: [{ visibility: "off" }]
//               },
//               {
//                 featureType: "road",
//                 stylers: [{ visibility: "simplified" }]
//               },
//               {
//                 elementType: "labels",
//                 stylers: [{ visibility: "off" }]
//               },
//               {
//                 featureType: "water",
//                 elementType: "geometry",
//                 stylers: [{ color: theme.palette.primary.dark }]
//               },
//               {
//                 featureType: "landscape",
//                 elementType: "geometry",
//                 stylers: [{ color: theme.palette.grey[800] }]
//               }
//             ],
//             disableDefaultUI: true,
//             zoomControl: true,
//             backgroundColor: theme.palette.primary.dark
//           }}
//           onLoad={map => {
//             mapRef.current = map;
//           }}
//         >
//           {countries.map((country) => (
//             <Marker
//               key={country.name}
//               position={{ lat: country.lat, lng: country.lng }}
//               icon={{
//                 path: google.maps.SymbolPath.CIRCLE,
//                 scale: 8,
//                 fillColor: theme.palette.secondary.main,
//                 fillOpacity: 0.8,
//                 strokeColor: 'white',
//                 strokeWeight: 2
//               }}
//             >
//               {/* Custom Marker Overlay */}
//               <Box
//                 sx={{
//                   position: 'absolute',
//                   transform: 'translate(-50%, -50%)',
//                   width: 120,
//                   backgroundColor: 'rgba(0,0,0,0.7)',
//                   borderRadius: 2,
//                   p: 1,
//                   textAlign: 'center',
//                   color: 'white',
//                   visibility: 'hidden',
//                   '&:hover': {
//                     visibility: 'visible'
//                   }
//                 }}
//               >
//                 <Typography variant="subtitle2">{country.name}</Typography>
//                 <Typography variant="caption">
//                   {country.projects} {country.projects > 1 ? 'Projects' : 'Project'}
//                 </Typography>
//               </Box>
//             </Marker>
//           ))}
//         </GoogleMap>
//       </LoadScript>

//       {/* Pulsing animation container */}
//       {countries.map((country) => (
//         <Box
//           key={`pulse-${country.name}`}
//           sx={{
//             position: 'absolute',
//             top: `calc(50% - ${((country.lat - center.lat) / 180) * 100}%)`,
//             left: `calc(50% + ${((country.lng - center.lng) / 360) * 100}%)`,
//             transform: 'translate(-50%, -50%)',
//             zIndex: 1,
//             pointerEvents: 'none'
//           }}
//         >
//           <Box
//             sx={{
//               position: 'relative',
//               width: 40,
//               height: 40,
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center'
//             }}
//           >
//             {/* Pulsing circle */}
//             <Box
//               sx={{
//                 position: 'absolute',
//                 width: '100%',
//                 height: '100%',
//                 backgroundColor: theme.palette.secondary.main,
//                 borderRadius: '50%',
//                 opacity: 0.6,
//                 animation: 'pulse 3s infinite',
//                 '@keyframes pulse': {
//                   '0%': {
//                     transform: 'scale(0.8)',
//                     opacity: 0.6
//                   },
//                   '70%': {
//                     transform: 'scale(1.3)',
//                     opacity: 0
//                   },
//                   '100%': {
//                     transform: 'scale(0.8)',
//                     opacity: 0
//                   }
//                 }
//               }}
//             />
//             <LocationOn sx={{
//               color: theme.palette.secondary.main,
//               fontSize: '2rem',
//               filter: 'drop-shadow(0 0 4px rgba(0,0,0,0.5))'
//             }} />
//           </Box>
//         </Box>
//       ))}

//       {/* Country list overlay */}
//       <Box sx={{
//         position: 'absolute',
//         bottom: 40,
//         left: 0,
//         width: '100%',
//         zIndex: 2,
//         px: 2
//       }}>
//         <Box sx={{
//           display: 'flex',
//           flexWrap: 'wrap',
//           justifyContent: 'center',
//           gap: 2,
//           maxWidth: 1200,
//           mx: 'auto',
//           backgroundColor: 'rgba(0,0,0,0.6)',
//           backdropFilter: 'blur(5px)',
//           borderRadius: 4,
//           p: 3
//         }}>
//           {countries.map((country) => (
//             <Box key={`list-${country.name}`} sx={{
//               display: 'flex',
//               alignItems: 'center',
//               color: 'white',
//               px: 2,
//               py: 1,
//               borderRadius: 2,
//               '&:hover': {
//                 backgroundColor: 'rgba(255,255,255,0.2)'
//               }
//             }}>
//               <Box sx={{
//                 width: 12,
//                 height: 12,
//                 backgroundColor: theme.palette.secondary.main,
//                 borderRadius: '50%',
//                 mr: 1.5,
//                 boxShadow: `0 0 0 2px ${theme.palette.secondary.light}`
//               }} />
//               <Typography variant="subtitle2" sx={{ mr: 1 }}>
//                 {country.name}
//               </Typography>
//               <Typography variant="body2" sx={{
//                 color: theme.palette.secondary.light,
//                 fontWeight: 700
//               }}>
//                 {country.projects}
//               </Typography>
//             </Box>
//           ))}
//         </Box>
//       </Box>
//     </Box>
//   );
// };

// export default FootprintMap;
